import { useEffect }   from 'react';
import { useLocation } from 'react-router-dom';

export default function AnalyticsListener() {
  const { pathname } = useLocation();

  useEffect(() => {
    console.log('[GA4] sending gtag page_view for', pathname);
    window.gtag?.('event', 'page_view', {
      page_path:     pathname,
      page_location: window.location.href,
      page_title:    document.title,
    });
  }, [pathname]);

  return null;
}